import React, { ReactNode, Suspense, useEffect, useLayoutEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Navbar } from './sub/Navbar';
import { PageLoader } from './sub/PageLoader';

import { closeAllModals } from '../store/modal.slice';

import { useCreateSession } from '../hooks/auth-ux';

import { AuthHelper } from '../helpers/auth.helper';

interface AppProps {
    children: ReactNode;
};
export const App = (props: AppProps) => {
    const { children } = props;

    const location = useLocation();
    const dispatch = useDispatch();

    useLayoutEffect(() => {
        dispatch(closeAllModals());
        // eslint-disable-next-line
    }, [location]);

    const { mutate: createSession } = useCreateSession();

    useEffect(() => {
        if (AuthHelper.noSessionActive()) createSession();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isMcsaRoute = location.pathname.includes('/mcsa');

    const isNavbarVisible = () => {
        const excludedPaths = ['/auth', '/gmail', '/outlook', '/mcsa'];

        if (excludedPaths.some(path => location.pathname.includes(path))) {
            return false;
        };

        return true;
    };

    return (
        <Suspense fallback={isMcsaRoute ? null : <PageLoader />}>
            <div className="app">
                {isNavbarVisible() && (
                    <Fragment>
                        <Navbar />
                        <br /><br /><br />
                    </Fragment>
                )}
                {children}
            </div>
        </Suspense>
    );
};